'use client'

import { HugeiconsIcon } from '@hugeicons/react'
import {
  AiBrain04Icon,
  Flag02Icon,
  Flowchart02Icon,
  PlusSignIcon,
  VariableIcon,
  WorkflowCircle06Icon,
} from '@hugeicons-pro/core-stroke-rounded'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import type { Step } from '@/lib/commands/graph-serialize'

const items = [
  {
    kind: 'tool' as const,
    label: 'Fetch data',
    description: 'Pull live data from the workspace.',
    icon: WorkflowCircle06Icon,
  },
  {
    kind: 'ai_step' as const,
    label: 'Ask AI to summarize',
    description: 'Send data through Claude to write the message.',
    icon: AiBrain04Icon,
  },
  {
    kind: 'transform' as const,
    label: 'Set a variable',
    description: 'Compute a value for later steps.',
    icon: VariableIcon,
  },
  {
    kind: 'end' as const,
    label: 'End',
    description: 'Stop the command.',
    icon: Flag02Icon,
  },
]

export function AddStepMenu({
  hasEnd,
  onAdd,
}: {
  hasEnd: boolean
  onAdd: (kind: Step['kind']) => void
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button type="button" variant="outline" size="sm">
          <HugeiconsIcon icon={PlusSignIcon} className="size-4" />
          Add step
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-72">
        {items.map((item) => (
          <DropdownMenuItem
            key={item.kind}
            disabled={item.kind === 'end' && hasEnd}
            onClick={() => onAdd(item.kind)}
            className="items-start gap-3 py-2"
          >
            <HugeiconsIcon icon={item.icon} className="mt-0.5 size-4" />
            <span>
              <span className="block font-medium">{item.label}</span>
              <span className="block text-xs text-atrium-black/60">{item.description}</span>
            </span>
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator />
        <DropdownMenuSub>
          <DropdownMenuSubTrigger className="gap-3">
            <HugeiconsIcon icon={Flowchart02Icon} className="size-4" />
            Advanced
          </DropdownMenuSubTrigger>
          <DropdownMenuSubContent className="w-72">
            <DropdownMenuItem onClick={() => onAdd('condition')} className="items-start gap-3 py-2">
              <HugeiconsIcon icon={Flowchart02Icon} className="mt-0.5 size-4" />
              <span>
                <span className="block font-medium">If / then</span>
                <span className="block text-xs text-atrium-black/60">Branch based on a condition.</span>
              </span>
            </DropdownMenuItem>
          </DropdownMenuSubContent>
        </DropdownMenuSub>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
